import {
  useState, useEffect, useRef, useMemo,
} from 'react'
import estimateLoyaltyPoints from '../api/loyalty/estimatePoints'

const useLoyaltyPointsEstimation = ({
  items, memberType, accessToken, cartTotal, itemSku, couponCode = null, refreshKey = 0,
}) => {
  const [points, setPoints] = useState(null)
  const [loading, setLoading] = useState(false)
  const [rewards, setRewards] = useState(null)
  const [bonus, setBonus] = useState(null)

  // Always holds the latest items without being a dependency
  const itemsRef = useRef(items)
  itemsRef.current = items

  const discountItemSkuRef = useRef(itemSku)
  discountItemSkuRef.current = itemSku

  // Primitive string — stable across re-renders when cart content hasn't changed
  const fingerprint = useMemo(() => {
    if (!items || items.length === 0) return ''
    return items.map(i => `${i?.product?.sku || i?.sku}:${i?.modifiers?.quantity || i?.qty}:${i?.discountAmount || 0}`).join(',')
  }, [items])

  useEffect(() => {
    if (!fingerprint) {
      setPoints(null)
      setLoading(false)
      return
    }
    setLoading(true)
    estimateLoyaltyPoints({
      items: itemsRef.current, memberType, accessToken, cartTotal, itemSku: discountItemSkuRef.current,
    })
      .then(res => {
        setPoints(res?.data?.data?.earnPoints ?? null)
        setRewards(res?.data?.data?.redeemableRewards?.length > 0 ? res?.data?.data?.redeemableRewards : null)
        setBonus(res?.data?.data?.bonus?.banners?.length > 0 ? res?.data?.data?.bonus?.banners : null)
      })
      .catch(() => setPoints(null))
      .finally(() => setLoading(false))
  }, [fingerprint, accessToken, cartTotal, memberType, couponCode, refreshKey])

  return {
    points, loading, rewards, bonus,
  }
}

export default useLoyaltyPointsEstimation
